import { call, put } from 'redux-saga/effects'
import api from '../../utils/api'
import actions from './actions'

const querySites = params => call(api.getSites, params && params.query)
const queryBySiteCode = params => call(api.getSiteBySiteCode, params && params.query)

function* fetchSites(action = {}) {
  yield put({ type: actions.fetchPending })

  let sites
  if (action.params && action.params.query && action.params.query.match(/^[0-9]+$/)) {
    sites = yield queryBySiteCode(action.params)
  } else {
    sites = yield querySites(action.params)
  }
  yield put({ type: actions.setSites, sites: sites })
}

export default fetchSites



// WEBPACK FOOTER //
// ./src/store/sites/saga.js